<template>
  <div class="animated fadeIn">
    <p class="text-info">Hello World</p>

    <div class="columns medium-3" v-for="result in results">
      <div class="card">
        <div class="card-divider">
          {{ result.name }}
        </div>
        <div class="card-section">
          <p>{{ result.email }}.</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import axios from 'axios'

  export default {
    name: 'dashboard',
    data: function () {
      return {
        results: []
      }
    },
    mounted () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue